/**
 * @desc 计算签名
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 通过微应用appKey获取的jsticket */
  jsticket?: string;
  /** 自定义固定字符串 */
  nonceStr?: string;
  /** 当前时间戳 */
  timeStamp?: number;
  /** 当前页面URL */
  url?: string;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/dingding/sign',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/dingding/sign',

    params,
  });
}
